import createPanZoom, { PanZoom, PanZoomOptions } from 'panzoom'
import * as React from 'react'
import { useEffect, useRef, useState } from 'react'

/**
 * HTML / SVG panzoom React hook
 * @param panzoomOptions
 */
export const usePanzoom = (panzoomOptions?: PanZoomOptions) => {
    const panzoomRef = useRef(null)

    const [isPanzoomEnabled, setIsPanzoomEnabled] = useState<boolean>(false)
    const [isPanzoomPaused, setIsPanzoomPaused] = useState<boolean>(false)
    const [element, setElement] = useState<HTMLElement | SVGElement>()
    const [panzoom, setPanzoom] = useState<PanZoom>()
    // const rect = useRect(panzoomRef)
    // const transform = panzoom && panzoom.getTransform()
    // const x = transform ? transform.x : 0
    // const y = transform ? transform.y : 0
    // const scale = transform ? transform.scale : 1
    // const position = {
    //     x,
    //     y,
    //     scale,
    // }

    const setPan = () => {}
    const setZoom = () => {}

    // Mounting ref
    useEffect(() => {
        if (panzoomRef) {
            // @ts-ignore
            startPanzoom(panzoomRef?.current)
            setIsPanzoomEnabled(true)
        }
    }, [panzoomRef])

    // Cleaning
    useEffect(() => {
        return () => {
            stopPanzoom()
        }
    }, [])

    const resumePanzoom = () => {
        if (panzoom) {
            panzoom.resume()
            setIsPanzoomPaused(false)
        }
    }

    const pausePanzoom = () => {
        if (panzoom) {
            panzoom.pause()
            setIsPanzoomPaused(true)
        }
    }

    const togglePauseResumePanzoom = () => {
        if (panzoom) {
            isPanzoomPaused ? resumePanzoom() : pausePanzoom()
        }
    }

    const startPanzoom = (
        element: HTMLElement | SVGElement,
        options?: PanZoomOptions
    ) => {
        const combinedOptions = { ...panzoomOptions, ...options }
        setElement(element)
        setPanzoom(createPanZoom(element, combinedOptions))
    }

    const stopPanzoom = () => {
        if (panzoom) {
            panzoom.dispose()
            // @ts-ignore
            setPanzoom(null)
            setIsPanzoomEnabled(false)
        }
    }

    const toggleStartStopPanzoom = () => {
        // @ts-ignore
        panzoom ? stopPanzoom() : startPanzoom(element)
    }

    const resetPanzoom = (options?: PanZoomOptions) => {
        stopPanzoom()
        // @ts-ignore
        startPanzoom(element, options)
    }

    const centerPanzoom = () => {
        // rect
        resetPanzoom({ autocenter: true })
    }

    const wrapperProps = {
        isPanzoomEnabled,
        isPanzoomPaused
    }

    const resetZoom = () => {
        // panzoom.zoomTo()
    }

    return {
        // rect,
        panzoomRef,
        centerPanzoom,
        panzoom,
        PanzoomWrapper,
        pausePanzoom,
        resetPanzoom,
        resumePanzoom,
        setPan,
        setZoom,
        startPanzoom,
        stopPanzoom,
        togglePauseResumePanzoom,
        toggleStartStopPanzoom,
        wrapperProps
    }
}

/**
 * Gets rid of blue outline in Chrome and Firefox
 */
export interface PanzoomWrapperProps {
    className?: string
    wrapperProps: {
        isPanzoomEnabled: boolean
        isPanzoomPaused: boolean
    }
    style?: React.CSSProperties
}

const PanzoomWrapper: React.FC<PanzoomWrapperProps> = (props) => {
    const { wrapperProps } = props
    if (!props.wrapperProps) {
        return <div />
    }
    const { isPanzoomEnabled, isPanzoomPaused } = wrapperProps
    const cursor = isPanzoomEnabled || !isPanzoomPaused ? 'move' : 'auto'
    const style: React.CSSProperties = {
        ...props.style,
        outline: 'none',
        cursor
    }

    return (
        <div className={props.className} style={style}>
            {props.children}
        </div>
    )
}
